import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Workspace { id: string; name: string; plan: string; }
interface WorkspaceState { current: Workspace | null; list: Workspace[]; }

const initialState: WorkspaceState = { current: null, list: [] };

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setWorkspaces: (state, action: PayloadAction<Workspace[]>) => {
      state.list = action.payload;
    },
    setCurrentWorkspace: (state, action: PayloadAction<Workspace>) => {
      state.current = action.payload;
    },
  },
});

export const { setWorkspaces, setCurrentWorkspace } = workspaceSlice.actions;
export default workspaceSlice.reducer;
